import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

const Hero = () => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // cPanel domain ke hisab से live backend API URL (Corrected to get_banners/)
        const BASE_URL = window.location.hostname === 'localhost'
            ? 'http://127.0.0.1:8003'
            : 'https://rbmchemicals.com';

        fetch(`${BASE_URL}/api/get_banners/`)
            .then(res => {
                if (!res.ok) {
                    throw new Error("Network response was not ok");
                }
                return res.json();
            })
            .then(data => {
                setBanners(data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching banners:", err);
                setLoading(false);
            });
    }, []);

    return (
        <section className="relative w-full h-[180px] md:h-[650px] bg-gray-900 overflow-hidden">
            {loading ? (
                <div className="w-full h-full flex items-center justify-center text-white">
                    <p>Loading Banners...</p>
                </div>
            ) : banners.length > 0 ? (
                <Swiper
                    modules={[Navigation, Autoplay, EffectFade]}
                    navigation={true}
                    autoplay={{ delay: 5000 }}
                    effect="fade"
                    className="w-full h-full"
                >
                    {banners.map((banner) => (
                        <SwiperSlide key={banner.id}>
                            <div className="w-full h-full relative">
                                <img
                                    src={banner.image}
                                    alt={banner.title || "Banner"}
                                    className="w-full h-full object-cover object-center"
                                />
                                {/* Gradient Overlay */}
                                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                                    <h1 className="text-2xl md:text-5xl font-bold text-white uppercase text-center px-4">
                                        {banner.title}
                                    </h1>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <div className="w-full h-full flex items-center justify-center text-white">
                    <p>No Banners Found</p>
                </div>
            )}
        </section>
    );
};

export default Hero;